/* PQ PDP preview: color legend, size guide link, sticky ATC */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* selected color name in legend */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var fs = input.closest('.product-form__input');
    var span = fs && fs.querySelector('[data-pq-selected]');
    if (span) span.textContent = ' ' + input.value;
    if (fs) fs.classList.remove('pq-attention');
  });

  /* size guide link opens accordion */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pq-sizeguide]');
    if (!a) return;
    var d = document.getElementById('pq-size-guide');
    if (!d) return;
    e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* sticky ATC */
  function priceText() {
    var c = $('.product__info-container [id^="price-"] .price'); if (!c) return '';
    var el = c.classList.contains('price--on-sale') ? $('.price__sale .price-item--sale', c) : $('.price__regular .price-item--regular', c);
    return el ? el.textContent.trim() : '';
  }
  function mainBtn() { return $('.product__info-container .product-form__submit'); }
  function initSticky() {
    if (!mainBtn() || $('.pq-sticky-atc')) return;
    var title = ($('.product__title h1') || {}).textContent || '';
    var bar = document.createElement('div');
    bar.className = 'pq-sticky-atc'; bar.setAttribute('aria-hidden', 'true');
    var SHARE = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" x2="12" y1="2" y2="15"/></svg>';
    bar.innerHTML = '<button type="button" class="pq-sticky-atc__share" aria-label="Share" tabindex="-1">' + SHARE + '</button><button type="button" class="pq-sticky-atc__btn" tabindex="-1"></button><div class="pq-toast" role="status" aria-live="polite"></div>';
    var shareBtn = $('.pq-sticky-atc__share', bar);
    shareBtn.addEventListener('click', function () {
      var data = { title: title.trim() || document.title, url: location.href.split('#')[0] };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      function toast(msg) { var t = $('.pq-toast', bar); t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 1800); }
      function legacy() { var ta = document.createElement('textarea'); ta.value = data.url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); var ok = false; try { ok = document.execCommand('copy'); } catch (e) {} ta.remove(); toast(ok ? 'Link copied' : data.url); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(data.url).then(function () { toast('Link copied'); }, legacy); else legacy();
    });
    document.body.appendChild(bar);
    var sbtn = $('.pq-sticky-atc__btn', bar);
    function sync() {
      var m = mainBtn(); if (!m) return;
      sbtn.textContent = (m.querySelector('span') || m).textContent.trim();
      sbtn.classList.toggle('is-unavailable', m.disabled);
    }
    sbtn.addEventListener('click', function () {
      var m = mainBtn(); if (!m) return;
      if (m.disabled) {
        var sets = $$('variant-selects .product-form__input');
        var target = sets.filter(function (f) { return /size/i.test((f.querySelector('legend') || {}).textContent || ''); })[0] || sets[0] || m;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.classList.remove('pq-attention'); void target.offsetWidth; target.classList.add('pq-attention');
        return;
      }
      m.click();
    });
    /* v29: scroll-triggered. One IntersectionObserver on the main ATC; bar shows once it is fully above the viewport (below the sticky header). */
    var vis = false, lastEntry = null;
    function hdrH() { var h = $('.section-header'); if (!h) return 0; var p = getComputedStyle(h).position; return (p === 'sticky' || p === 'fixed') && !h.classList.contains('scrolled-past-header') ? Math.round(h.getBoundingClientRect().height) : 0; }
    function apply(show) {
      show = show && MQ.matches;
      if (show) sync();
      vis = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      sbtn.tabIndex = show ? 0 : -1; shareBtn.tabIndex = show ? 0 : -1;
      var h = Math.ceil(bar.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--pq-sticky-h', h + 'px');
      document.body.classList.toggle('pq-has-sticky', MQ.matches);
      document.dispatchEvent(new CustomEvent('pq:sticky-atc', { detail: { visible: show, height: show ? h : 0 } }));
    }
    function judge(e) { lastEntry = e; apply(!e.isIntersecting); }
    var io = null;
    function observe() {
      if (io) io.disconnect();
      io = new IntersectionObserver(function (es) { judge(es[es.length - 1]); }, { rootMargin: '-' + hdrH() + 'px 0px 100000px 0px', threshold: 0 });
      var m = mainBtn(); if (m) io.observe(m);
    }
    apply(false); observe();
    document.addEventListener('pq:main-atc-replaced', observe);
    window.addEventListener('resize', function () { clearTimeout(bar.__rt); bar.__rt = setTimeout(function () { observe(); }, 150); });
    if (MQ.addEventListener) MQ.addEventListener('change', function () { apply(false); observe(); });
    if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
    sync();
  }



  /* v18: thumbnail / color switch = ONE white cover, instant jump(s) underneath, ONE fade once the final image is decoded. */
  /* v19: pubsub.js may not be defined yet when this file runs (seen in WebKit) -> subscribe lazily */
  function onVariant(cb) {
    function sub() { if (window.subscribe && window.PUB_SUB_EVENTS) { window.subscribe(PUB_SUB_EVENTS.variantChange, cb); return true; } return false; }
    if (sub()) return;
    var tries = 0; (function retry() { if (sub() || ++tries > 40) return; setTimeout(retry, 50); })();
  }
  var pqRM = window.matchMedia('(prefers-reduced-motion: reduce)');
  function pqCover(viewer) {
    clearTimeout(viewer.__pqFT); viewer.classList.remove('pq-fade--out'); viewer.classList.add('pq-fade');
  }
  function pqRelease(gal) {
    var viewer = gal.elements.viewer;
    var target = viewer.querySelector('li.is-active[data-media-id]');
    var list = target && target.parentElement;
    if (list) { list.style.scrollBehavior = 'auto'; if (list.scrollWidth > list.clientWidth && Math.abs(list.scrollLeft - target.offsetLeft) > 1) list.scrollLeft = target.offsetLeft; }
    var img = target && target.querySelector('img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
    var ready = img && img.decode ? img.decode().catch(function () {}) : Promise.resolve();
    var done = false;
    var go = function () {
      if (done) return; done = true;
      requestAnimationFrame(function () {
        if (list) list.style.scrollBehavior = '';
        if (gal.__pqHold || gal.__pqPending) return;
        if (!viewer.classList.contains('pq-fade')) return;
        requestAnimationFrame(function () {
          viewer.classList.add('pq-fade--out');
          viewer.__pqFT = setTimeout(function () { viewer.classList.remove('pq-fade', 'pq-fade--out'); }, 320);
        });
      });
    };
    ready.then(go); setTimeout(go, 700);
  }
  function pqFade(gal, id, hold) {
    var viewer = gal && gal.elements && gal.elements.viewer;
    var target = viewer && viewer.querySelector('[data-media-id="' + id + '"]');
    var list = target && target.parentElement;
    if (!list) return;
    list.style.scrollBehavior = 'auto';
    var there = target.classList.contains('is-active') && Math.abs(list.scrollLeft - target.offsetLeft) < 2;
    if (!pqRM.matches && (hold || (!there && !gal.__pqHold))) pqCover(viewer);
    if (hold) {
      /* color switch: Dawn sorts the gallery + setActiveMedia, then publishes variantChange (our reorder runs synchronously).
         Hold the cover until that whole task is over, then fade once. */
      gal.__pqHold = true; gal.__pqPending = false; clearTimeout(gal.__pqPT);
      clearTimeout(gal.__pqHT);
      gal.__pqHT = setTimeout(function () { gal.__pqHold = false; pqRelease(gal); }, 0);
      return;
    }
    if (gal.__pqHold) return;
    /* Dawn scrolls the slide in a setTimeout(0); release runs right after it */
    setTimeout(function () { pqRelease(gal); }, 0);
  }
  function initFade(proto) {
    if (!proto || proto.__pqFade) return; proto.__pqFade = true;
    var prev = proto.setActiveMedia;
    /* prepend=true only comes from Dawn's product-info updateMedia (color switch) */
    proto.setActiveMedia = function (id, prepend) { if (!this.__pqInThumb) pqFade(this, id, prepend === true); return prev.apply(this, arguments); };
    /* thumbnail clicks: Dawn bound its handler at construction, so prepare the fade in capture phase */
    document.addEventListener('click', function (e) {
      var item = e.target.closest && e.target.closest('media-gallery [data-target]');
      if (!item || !e.target.closest('button')) return;
      var gal = item.closest('media-gallery');
      pqFade(gal, item.dataset.target, false);
      gal.__pqInThumb = true; setTimeout(function () { gal.__pqInThumb = false; }, 0);
    }, true);
    /* v19: color swatch = cover synchronously (capture phase, same task as the tap, before Dawn's handler and
       before any paint). Keep it through the section fetch + Dawn's reorder/setActiveMedia; the hold path above
       clears __pqPending once the selected color's featured media is active, then fades once after decode. */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio' || !input.closest('variant-selects')) return;
      var fs = input.closest('fieldset'); var lg = fs && fs.querySelector('legend');
      if (!lg || !/colou?r/i.test(lg.textContent)) return;
      var gal = document.querySelector('media-gallery'); var viewer = gal && gal.elements && gal.elements.viewer;
      if (!viewer) return;
      if (!pqRM.matches) pqCover(viewer);
      gal.__pqPending = true; clearTimeout(gal.__pqPT);
      gal.__pqPT = setTimeout(function () { gal.__pqPending = false; pqRelease(gal); }, 3000);
    }, true);
    /* variant without featured media / unavailable combo: Dawn never calls setActiveMedia(…, true) */
    onVariant(function () {
      var gal = document.querySelector('media-gallery');
      if (gal && gal.__pqPending) setTimeout(function () { if (!gal.__pqPending) return; gal.__pqPending = false; clearTimeout(gal.__pqPT); pqRelease(gal); }, 0);
    });
  }

  /* keep gallery in product media order (Dawn prepends the variant's featured media on color switch) */
  function initOrder() {
    if (window.customElements) customElements.whenDefined('media-gallery').then(function () {
      var C = customElements.get('media-gallery'), proto = C && C.prototype;
      if (!proto || proto.__pqNoPrepend) return;
      var orig = proto.setActiveMedia; proto.__pqNoPrepend = true;
      /* prepend=true = Dawn's updateMedia after it reordered the slides to the fetched HTML (selected color first).
         Restore our order HERE, synchronously, before Dawn scrolls to the slide - so no later re-sort can move the
         slider under the user (that late re-sort was the 'jump to first image' on iPhone). */
      proto.setActiveMedia = function (id, prepend) { if (prepend === true && window.__pqFixOrder) try { window.__pqFixOrder(true); } catch (e) {} return orig.call(this, id, false); };
      initFade(proto);
    });
    var ul = $('media-gallery .product__media-list'); if (!ul) return;
    var key = function (id) { return (id || '').split('-').pop(); };
    var order = $$('li.product__media-item', ul).map(function (li) { return key(li.dataset.mediaId); });
    function fix(noActivate) {
      var gal = $('media-gallery'); var list = $('media-gallery .product__media-list'); if (!gal || !list) return;
      var rank = function (id) { var i = order.indexOf(key(id)); return i < 0 ? 1e3 : i; };
      var lis = $$('li.product__media-item', list);
      var sorted = lis.slice().sort(function (a, b) { return rank(a.dataset.mediaId) - rank(b.dataset.mediaId); });
      var changed = sorted.some(function (li, i) { return li !== lis[i]; });
      var tl = $('media-gallery .thumbnail-list');
      var ths = tl ? $$('.thumbnail-list__item', tl) : [];
      var tsorted = ths.slice().sort(function (a, b) { return rank(a.dataset.target) - rank(b.dataset.target); });
      var tchanged = tsorted.some(function (li, i) { return li !== ths[i]; });
      if (!changed && !tchanged) return;
      if (changed) sorted.forEach(function (li) { list.appendChild(li); });
      if (tchanged) tsorted.forEach(function (li) { tl.appendChild(li); });
      var sl = $('media-gallery slider-component'); if (sl && sl.initPages) try { sl.initPages(); } catch (e) {}
      if (noActivate === true) return;
      var act = $('li.product__media-item.is-active', list);
      if (act && gal.setActiveMedia) gal.setActiveMedia(act.dataset.mediaId, false);
    }
    window.__pqFixOrder = fix;
    /* safety net only: by now the order is already right, so these are no-ops (no scroll) */
    onVariant(function () { fix(); });
  }

  function init() {
    try { initOrder(); } catch (err) { console.warn('pq order', err); }
    try { initSticky(); } catch (err) { console.warn('pq sticky', err); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
